// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
:host {
  display: inline-flex;
  vertical-align: top;
  line-height: 1;
}

.checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  line-height: 1;
}

.checkbox-label {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  max-width: 300px;
  cursor: pointer;
  line-height: 1.2;
}

.checkbox-label-img {
  margin-right: 2px;
  height: 10px;
}

input[type=checkbox] {
  -webkit-appearance: none;
          appearance: none;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  margin: 0;
  padding: 0;
  border: 1px solid #9dbcda;
  border-radius: 5px;
  background: transparent;
  display: grid;
  place-content: center;
  cursor: pointer;
}
input[type=checkbox]::before {
  content: "";
  width: 8px;
  height: 5px;
  border-left: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  transform: rotate(-45deg) translate(0, -1px) scale(0);
}
input[type=checkbox]:checked {
  background: #3e84c9;
  border-color: #3e84c9;
}
input[type=checkbox]:checked::before {
  transform: rotate(-45deg) translate(0, -1px) scale(1);
}
input[type=checkbox]:hover:not(:disabled) {
  border-color: #74909f;
}
input[type=checkbox]:disabled {
  border-color: #607387;
  cursor: default;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
